// 액션 확인 모달 — useUI.modal을 dim 배경 + 본문 + 확인/취소로 렌더 (HTML은 safe 렌더링)
import { useUI } from '../lib/uiStore';
import { renderSafeHtml } from '../lib/sanitize';

export function ModalHost() {
  const modal = useUI((s) => s.modal);
  const close = useUI((s) => s.closeModal);

  return (
    <div
      className={`modal-bg ${modal.open ? 'open' : ''}`}
      id="actionModal"
      onClick={(e) => {
        if (e.target === e.currentTarget) close();
      }}
    >
      <div className="modal">
        <div className="modal-title">{modal.title}</div>
        <div className="modal-sub">{renderSafeHtml(modal.sub)}</div>
        {modal.body && (
          modal.bodyPlain
            ? <div style={{ marginTop: 16 }}>{renderSafeHtml(modal.body)}</div>
            : <div className="reason-box reason-warn">⚠ <div>{renderSafeHtml(modal.body)}</div></div>
        )}
        <div className="modal-foot">
          <button className="btn btn-ghost" onClick={close}>취소</button>
          <button
            className="btn btn-pri"
            onClick={() => {
              modal.onConfirm?.();
              close();
            }}
          >
            {modal.confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
